export function TermsPage() {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-fg">Terms of Service</h1>
        <p className="mt-1 text-sm text-fg-2">
          The terms for using Bhandari Photos.
        </p>
      </div>

      <div className="space-y-5 text-sm leading-relaxed text-fg-2">
        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">About this service</h2>
          <p>
            Bhandari Photos is a private, invite-only gallery for sharing photos
            and videos from shared events. By signing in and using it, you agree
            to these terms. If you don&rsquo;t agree, please don&rsquo;t use the
            service.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">Access</h2>
          <p>
            You sign in with your Google account, and an administrator decides
            which events you can view and contribute to. Please keep your access
            to yourself &mdash; don&rsquo;t share your sign-in, and don&rsquo;t
            try to reach events you weren&rsquo;t granted.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">Your content</h2>
          <p>
            You keep ownership of the photos and videos you upload. By uploading,
            you confirm you have the right to share that content, and you allow
            the other authorized members of an event to view and download it
            within the gallery. Only upload content that is yours to share, and
            nothing unlawful or that infringes someone else&rsquo;s rights or
            privacy.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">Respect for others</h2>
          <p>
            These are shared memories of real people. Treat the media as private
            to the group, and don&rsquo;t republish or redistribute other
            members&rsquo; content outside the gallery without their consent.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">Acceptable use</h2>
          <p>
            Don&rsquo;t attempt to break, overload, or gain unauthorized access to
            the service or its underlying storage, and don&rsquo;t use it to store
            or distribute malware or illegal material. Administrators may remove
            content or revoke access to enforce these terms or to honor a removal
            request.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">Availability &amp; &ldquo;as is&rdquo;</h2>
          <p>
            This is a personal, best-effort service provided free of charge and
            &ldquo;as is,&rdquo; without warranties of any kind. We don&rsquo;t
            guarantee it will always be available or that uploaded content will be
            preserved indefinitely, so please keep your own copies of anything
            important. To the extent permitted by law, the operators aren&rsquo;t
            liable for any loss of data or indirect damages arising from your use
            of the service.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">Changes</h2>
          <p>
            We may update these terms from time to time. Continuing to use the
            service after a change means you accept the updated terms.
          </p>
        </section>

        <section className="space-y-2">
          <h2 className="text-base font-semibold text-fg">Contact</h2>
          <p>
            For any questions about these terms, or to request that content be
            removed, please reach out to the site owner.
          </p>
        </section>
      </div>
    </div>
  );
}
